import React, { useContext } from "react";

import { TTip } from "@data-types/offer/event-row/EventRow";
import { EventContext } from "@gp/components";
import { toDisplayOdd } from "@gp/utility";
import { useRootAppStore } from "@hooks";
import { BetBuilderModeContext } from "@state/context/bet-builder/BetBuilderModeContext";
import { useOfferContext } from "@state/hooks/offer/useOfferContext";
import classNames from "classnames";
import { observer } from "mobx-react";

export const RegularTipButton = observer(function RegularTipButton(props: {
	tip: TTip["tip"];
	isLong: boolean;
	isGridItem?: boolean;
	baseCssClass: string;
	hasPlaceHolders: boolean;
}) {
	//#region hooks
	const rootStore = useRootAppStore();
	const offerStore = useOfferContext();
	const event = useContext(EventContext);

	const {
		betBuilderStore: { nextOddsOff },
		betSlipStore: {
			betSlipState: { isMultiOfferEventPresent, isMultiOfferSelected },
		},
	} = rootStore;

	//#endregion hooks

	const isBetBuilderTab = useContext(BetBuilderModeContext);
	const isSelected =
		isBetBuilderTab && !rootStore.betSlipStore.isOneClickBetActive
			? rootStore.betSlipStore.betSlipState.isMultiOfferSelected(
					event?.id,
					props.tip?.id
				)
			: rootStore.betSlipStore.isTipSelected(props?.tip?.id || "");
	const displayValue = toDisplayOdd(props.tip?.value || 0);

	const eventKeys = offerStore.eventKeysMap.get(event.id);
	const key = eventKeys?.get(props.tip?.keyId || "");

	const isLocked = isSelected
		? false
		: event?.isLocked || key?.isLocked || props.tip?.isLocked;

	if (!props.hasPlaceHolders && displayValue == null) {
		return null;
	}
	let isBetBuilderTipHidden = false;
	let isBetBuilderTipSelected = false;
	let betBuilderAvailableTip = null;

	//@ts-expect-error
	if (offerStore.betBuilderAvailableTips) {
		//@ts-expect-error
		betBuilderAvailableTip = offerStore.betBuilderAvailableTips.get(
			props.tip?.id
		);

		if (isBetBuilderTab) {
			//@ts-expect-error
			if (isMultiOfferEventPresent(offerStore.event.id)) {
				if (isMultiOfferSelected(props.tip?.eventId, props.tip?.id)) {
					isBetBuilderTipSelected = true;
				} else if (!nextOddsOff) {
					if (betBuilderAvailableTip) {
						isBetBuilderTipHidden = false;
					} else {
						isBetBuilderTipHidden = true;
					}
				}
			} else {
				isBetBuilderTipHidden = false;
			}
		}
	}

	const tipValue =
		isBetBuilderTab && betBuilderAvailableTip && !nextOddsOff
			? toDisplayOdd(betBuilderAvailableTip.providerValue)
			: displayValue;
	const isButtonDisabled = isLocked || displayValue == null;
	const displayTipValue = tipValue != null ? tipValue : "-";

	//#region css classes
	const buttonClasses = classNames(props.baseCssClass, "quota", {
		"quota--oneclick": rootStore.betSlipStore.isOneClickBetActive,
		"quota--bb": isBetBuilderTab,
		"quota--dynamic": isBetBuilderTab && !nextOddsOff,
		"quota--static": isBetBuilderTab && nextOddsOff,
		// "is-long": props.isLong && !props.isGridItem,
		"is-active": isSelected,
		"is-dec": props.tip?.indicator === -1,
		"is-inc": props.tip?.indicator === 1,
	});

	const tipClasses = classNames("quota__tip", {
		"quota__tip--long": props.isLong,
	});

	const quoteClasses = classNames("quota__odd", {
		"quota__odd--long": props.isLong,
	});

	//#endregion css classes

	return (
		<button
			type="button"
			title={props.tip?.displayTip}
			onClick={() => {
				if (
					rootStore.waitingPeriodStore.timeLeft > 0 &&
					rootStore.betSlipStore.isOneClickBetActive
				) {
					rootStore.waitingPeriodStore.activatePopup();
					return;
				}

				if (
					!rootStore.betSlipStore.isOneClickBetActive &&
					isBetBuilderTab
				) {
					rootStore.betBuilderStore.updateQuotaAndSetAvailableOffers(
						props.tip,
						event
					);
				} else {
					rootStore.betSlipStore.addRemoveOffer(props.tip);
				}
			}}
			disabled={isButtonDisabled || isBetBuilderTipHidden}
			className={buttonClasses}
		>
			<div className={tipClasses} title={props.tip?.displayTip}>
				{props.tip?.displayTip}
			</div>

			{nextOddsOff ? (
				<div className={quoteClasses}>{displayTipValue}</div>
			) : isBetBuilderTipSelected ? (
				<div
					className={classNames(quoteClasses, "quota--dynamic__icon")}
				>
					<i className="u-icon u-icon--sml u-icon--check u-color--core--snow u-icon--animated--bounce-in" />
				</div>
			) : isBetBuilderTipHidden && !isLocked ? (
				<div
					className={classNames(quoteClasses, "quota--dynamic__icon")}
				>
					<i className="u-icon u-icon--sml u-icon--lock u-color--text--tertiary u-icon--animated--bounce-in" />
				</div>
			) : (
				<div className={quoteClasses}>{displayTipValue}</div>
			)}
		</button>
	);
});
